import { css } from '@emotion/css';

export const modalStyles = (height: number) => css`
  position: absolute;
  top: -${height}px;
  visibility: visible;
  right: 0;
  left: 0;
  transition: top 0.2s ease-in-out;
  ${bottomSheetRadius}
  ${boxShadow}
`;

export const boxShadow = css`
  box-shadow:
    0px -10px 10px rgb(0 0 0 / 2%),
    0px -2px 4px rgb(0 0 0 / 10%);
`;

export const bottomSheetRadius = css`
  border-top-left-radius: 1.2rem;
  border-top-right-radius: 1.2rem;
`;

export const bottomSheetContainer = css`
  height: 95vh;
`;

export const statusStyles = css`
  padding-inline-end: 10.4rem;
`;
